import { render } from "./ViewCart.vue?vue&type=template&id=2262d82f&scoped=true"
import script from "./ViewCart.vue?vue&type=script&lang=js"
export * from "./ViewCart.vue?vue&type=script&lang=js"

import "./ViewCart.vue?vue&type=style&index=0&id=2262d82f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lawrenj\\source\\repos\\Bitbucket_Cloud\\tgi_friends_of_gideons_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2262d82f"]])

export default __exports__